import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import {
  UserSubTenantAccessResponseSchema,
  UserSubTenantAccessListResponseSchema,
  SetUserSubTenantAccessSchema,
  UpdateUserSubTenantAccessSchema,
} from './user-sub-tenant-access.schema';
import { ErrorResponseSchema } from '../user-application-access/user-application-access.schema';

export const USER_SUB_TENANT_ACCESS_PATH = 'user-sub-tenant-access';

export const UserSubTenantAccessContract = terraContract
  .prefix(`/${USER_SUB_TENANT_ACCESS_PATH}`)
  .router({
    listUserAccess: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'List all user sub-tenant access configurations',
        inputStructure: 'detailed',
      })
      .output(UserSubTenantAccessListResponseSchema),
    getUserAccess: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'GET',
        path: '/{userId}',
        summary: 'Get user sub-tenant access configuration',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: z.object({
            userId: z.string(),
          }),
        }),
      )
      .output(UserSubTenantAccessResponseSchema)
      .errors({ NOT_FOUND: { status: 404, data: ErrorResponseSchema } }),
    setUserAccess: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'PUT',
        path: '/{userId}',
        summary: 'Set user sub-tenant access configuration',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: z.object({
            userId: z.string(),
          }),
          body: UpdateUserSubTenantAccessSchema,
        }),
      )
      .output(UserSubTenantAccessResponseSchema)
      .errors({
        BAD_REQUEST: { status: 400, data: ErrorResponseSchema },
        FORBIDDEN: { status: 403, data: ErrorResponseSchema },
        UNPROCESSABLE_CONTENT: { status: 422, data: ErrorResponseSchema },
      }),
    createUserAccess: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'POST',
        path: '/',
        summary: 'Create user sub-tenant access configuration',
        inputStructure: 'detailed',
        successStatus: 201,
      })
      .input(z.object({ body: SetUserSubTenantAccessSchema }))
      .output(UserSubTenantAccessResponseSchema)
      .errors({
        BAD_REQUEST: { status: 400, data: ErrorResponseSchema },
        FORBIDDEN: { status: 403, data: ErrorResponseSchema },
        CONFLICT: { status: 409, data: ErrorResponseSchema },
        UNPROCESSABLE_CONTENT: { status: 422, data: ErrorResponseSchema },
      }),
    deleteUserAccess: terraContract
      .meta({
        permissions: [PERMISSIONS.USER_ADMIN.name],
      })
      .route({
        method: 'DELETE',
        path: '/{userId}',
        summary: 'Delete user sub-tenant access configuration',
        inputStructure: 'detailed',
        successStatus: 204,
      })
      .input(
        z.object({
          params: z.object({
            userId: z.string(),
          }),
        }),
      )
      .output(z.null())
      .errors({
        FORBIDDEN: { status: 403, data: ErrorResponseSchema },
        NOT_FOUND: { status: 404, data: ErrorResponseSchema },
      }),
  });
